(function(){
"use strict";

angular.module('swapick.satellizer', ['satellizer', 'swapick.constants'])

.config(function ($authProvider, baseServerUrl) {
  /* configuring satellizer for working with django rest framework token auth */
  $authProvider.baseUrl = baseServerUrl;
  $authProvider.loginUrl = '/oauth/v2/token';
  $authProvider.authToken = 'Bearer';
  $authProvider.tokenPrefix = 'sp__satellizer';

});

})();


// WEBPACK FOOTER //
// ./src/config/satellizer-config.js